export const SET_PROFILE_USER = "SET_PROFILE_USER";
export const SET_PORTAL_TERMS_ACCEPTED = "SET_PORTAL_TERMS_ACCEPTED";
